'use client';

import { trackDiscoveryCallClick } from '@/lib/analytics';
import { getUserContext } from '@/lib/userContext';

interface DiscoveryCallButtonProps {
  pageLocation: string;
  buttonLocation: string;
  className?: string;
  children: React.ReactNode;
}

export default function DiscoveryCallButton({
  pageLocation,
  buttonLocation,
  className = '',
  children,
}: DiscoveryCallButtonProps) {
  const handleClick = () => {
    getUserContext().then(context => {
      const segment = context?.role || 'unauthenticated';
      trackDiscoveryCallClick(
        segment === 'super_admin' ? 'super_admin' : 
        segment === 'ops_admin' || segment === 'admin' ? 'admin' : 
        segment === 'team' ? 'team' : 
        segment === 'client' ? 'client' : 'unauthenticated',
        pageLocation,
        buttonLocation
      );
    });
  };

  return (
    <a
      href="https://calendly.com/john-smulo/purple-cow-unlimited-discovery-call"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={className}
    >
      {children}
    </a>
  );
}